export const deviceType=(()=>{
    var u = navigator.userAgent;
    let obj = {
        isApp: false,
        isAndroidApp: false,
        isIOSApp: false,
        isDoctor: false,
        isPatient: false,
        isWeiXin: false,
    }
    if (u.match(/hwkx_Android/i) != null) {
        obj['isApp'] = true;
        obj['isAndroidApp'] = true;
    }
    if (u.match(/hwkx_Ios/i) != null) {
        obj['isApp'] = true;
        obj['isIOSApp'] = true;
    }
    if (u.match(/shgzs_hwkx/i) != null) {
        obj['isDoctor'] = true;
    }
    if (u.match(/jtzyg_hwkx/i) != null) {
        obj['isPatient'] = true;
    }
    if (u.match(/MicroMessenger/i) != null) {
        obj['isWeiXin'] = true;
    }

    return obj;
})()